export enum BulkOperationType {
    UNKNOWN,
    PUBLISH,
    DELETE,
    EDIT,
    FULL_EXPORT_LISTING_WITH_OVERRIDE_CHANNEL,
    FULL_EXPORT_LISTINGS_WITHOUT_OVERRIDE_CHANNEL,
    BRAND_LEVEL_EDIT,
}
